export const emailValidation =
    /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/;
export const emptyTextInput = /^$|\s+/;
export const dateValidation = /^(0[1-9]|1[0-2])(-)([0-2][0-9]|3[0-1])\2(\d{4})$/;
